import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modelSelect", "messageInput", "response", "responseArea", "loading", "sendButton"]
  static values = { testUrl: String, sendUrl: String }

  async open(event) {
    event.preventDefault()
    
    this.testUrlValue = event.currentTarget.dataset.testUrl
    this.sendUrlValue = event.currentTarget.dataset.sendUrl
    
    this.modalTarget.classList.remove("hidden")
    this.responseAreaTarget.classList.add("hidden")
    this.loadingTarget.classList.remove("hidden")
    this.modelSelectTarget.innerHTML = '<option>Loading models...</option>'
    this.modelSelectTarget.disabled = true

    try {
      const response = await fetch(this.testUrlValue, {
        headers: { "Accept": "application/json" }
      })
      const data = await response.json()

      if (data.success) {
        this.modelSelectTarget.innerHTML = data.models.map(m => 
          `<option value="${m.id}">${m.display_name || m.id}</option>`
        ).join('')
        this.modelSelectTarget.disabled = false
      } else {
        this.modelSelectTarget.innerHTML = `<option>Error: ${data.error}</option>`
      }
    } catch (error) {
      this.modelSelectTarget.innerHTML = `<option>Error: ${error.message}</option>`
    }

    this.loadingTarget.classList.add("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")
  }

  async send(event) {
    event.preventDefault()

    const model = this.modelSelectTarget.value
    const message = this.messageInputTarget.value || "Hello! Please respond with a short greeting."

    this.sendButtonTarget.disabled = true
    this.sendButtonTarget.textContent = "Sending..."
    this.responseAreaTarget.classList.add("hidden")

    try {
      const response = await fetch(this.sendUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ model, message })
      })
      const data = await response.json()

      this.responseAreaTarget.classList.remove("hidden")
      
      if (data.success) {
        this.responseTarget.innerHTML = `<div class="text-emerald-700"><strong>Model:</strong> ${data.model}</div><div class="mt-2 p-3 bg-gray-50 rounded">${this.escapeHtml(data.response)}</div>`
      } else {
        this.responseTarget.innerHTML = `<div class="text-red-600"><strong>Error:</strong> ${this.escapeHtml(data.error)}</div>`
      }
    } catch (error) {
      this.responseAreaTarget.classList.remove("hidden")
      this.responseTarget.innerHTML = `<div class="text-red-600"><strong>Error:</strong> ${this.escapeHtml(error.message)}</div>`
    }

    this.sendButtonTarget.disabled = false
    this.sendButtonTarget.textContent = "Send Test"
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}
